import { Column, Entity, PrimaryColumn } from 'typeorm'

@Entity({ name: 'TSensorSetting' })
export class TSensorSetting {
  @PrimaryColumn({ unsigned: true })
  SNSSET_ID: number // sensors settings id

  @Column({ unsigned: true })
  DEVICE_ID: number

  @Column({ type: 'tinyint', unsigned: true })
  SNS_NUMBER: number // sensor number

  @Column({ type: 'double', unsigned: true })
  AREA_VALUE: number

  @Column({ type: 'tinyint' })
  AREA_ENABLE: number

  @Column({ type: 'tinyint', unsigned: true })
  VIEW_FLAGS: number

  @Column({ type: 'tinyint', unsigned: true })
  WARN_FLAGS: number

  @Column({ type: 'tinyint', unsigned: true })
  OTHER_FLAGS: number

  @Column({ type: 'double', unsigned: true })
  WARN_CHANGE: number

  @Column({ type: 'double', unsigned: true })
  WARN_HIGH: number

  @Column({ type: 'double', unsigned: true })
  WARN_LOW: number

  @Column({ type: 'double', unsigned: true })
  DELTA_VALUE: number

  @Column({ unsigned: true })
  MSG_ID_TOTAL: number

  @Column({ type: 'tinyint', unsigned: true })
  CALC_TOTAL: number

  @Column({ type: 'tinyint', unsigned: true })
  CALC_RATE: number

  @Column({ type: 'tinyint', unsigned: true })
  CALC_VOLUME: number

  @Column({ type: 'timestamp' })
  DATE_CREATE: Date

  @Column({ type: 'timestamp' })
  DATE_UPDATE: Date
}
